import React from 'react'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";

const CaseCreateReminder = ({ setOpen }) => {
    const navigate = useNavigate();
    
    return (
        <div>
            <Typography id="modal-modal-title" variant="h4" component="h2">
                <FormattedMessage id="Reminder" />
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormattedMessage id="remaindertext" />
            </Typography>
            <Box display="flex" justifyContent="space-between" mt={2.5}>
                <Button onClick={() => { localStorage.removeItem('urlPart'); setOpen(false); }} variant="contained" startIcon={<CloseIcon />}><FormattedMessage id="Close" /></Button>
                <Button onClick={() => { navigate(`create-patient/${localStorage.getItem('urlPart')}`); setOpen(false); }} variant="contained" endIcon={<ArrowRightIcon />}><FormattedMessage id="Continue" /></Button>
            </Box>
        </div>
    )
}

export default CaseCreateReminder;
